// La línea de «qué necesita de ti» encima de la caja del chat, cuando lo que pide es una subida (Entrega 3, flujo.md #1 y
// #4): lleva su botón, «Revisar la subida», que abre la ventana de esa subida con su Allow (la única, SubidasVivas). No
// es una tarjeta (D-036): es la línea que ya existía, con la acción que Pau iba a buscar a la bandeja.
import { Rocket } from 'lucide-react';
import { t } from '../../../i18n';
import { Boton } from '../ui';
import type { Despliegue } from './api';
import { useBandejaStore } from './store';

export function RevisarLaSubida({ d }: { d: Despliegue }) {
  const abrirSubida = useBandejaStore((s) => s.abrirSubida);
  return (
    <div
      data-testid="linea-ahora"
      data-tono="pide"
      className="mx-3 mt-1 flex min-h-10 shrink-0 items-center gap-2 rounded-o-m bg-oficina-te-necesita/10 py-1.5 pl-3.5 pr-1.5 text-o-texto text-oficina-te-necesita-claro sm:mx-5"
    >
      <Rocket className="h-4 w-4 shrink-0 text-oficina-te-necesita" aria-hidden />
      <span className="min-w-0 flex-1 truncate">{t('oficinaV2.lista.subida.quiere', { que: d.paraPau.titulo })}</span>
      <Boton variante="primario" tamano="sm" onClick={() => abrirSubida(d.runId)} data-testid="revisar-la-subida">
        {t('oficinaV2.lista.subida.revisarLaSubida')}
      </Boton>
    </div>
  );
}
